import { Menu as MantineMenu } from "@mantine/core"

const Menu = MantineMenu

Menu.Target = MantineMenu.Target
Menu.Dropdown = MantineMenu.Dropdown
Menu.Item = MantineMenu.Item
Menu.Label = MantineMenu.Label
Menu.Divider = MantineMenu.Divider

export { Menu }
